export default __webpack_public_path__ + "static/media/berlinmitte_light.8534550b.png";